import { Injectable, inject } from '@angular/core';
import {
	ActivatedRouteSnapshot,
	Router,
	UrlSegment,
	UrlSegmentGroup
} from '@angular/router';
import {Breadcrumb} from '../layout/breadcrumb/breadcrumb';
import {TitleCasePipe} from '@angular/common';
import {GovernmentComparisonContext} from '../models/reports/garfield-report';

@Injectable({
	providedIn: 'root'
})
export class BreadcrumbService {
	private router = inject(Router);
	private titleCasePipe = inject(TitleCasePipe);


	generateBreadcrumbs(segments: Array<UrlSegment>, govNameOrGovType?: string, routeSnapshot?: ActivatedRouteSnapshot) {
		// Reset breadcrumb array
		let breadcrumbs = new Array<Breadcrumb>();

		// Iterate through url segments to build breadcrumb items
		segments.forEach((s, i) => {
			// We only want the segments other than the last segment for the breadcrumbs
			if (i < segments.length - 1) {
				const route = this.routeLink(segments.slice(0, i + 1));
				// Lookup title from route config
				const title = this.router.config.find(r => r.path === route)?.title;
				// Handle case where title is not a static string; otherwise use title cased segment path
				let titleText = typeof title === 'string' ? title : this.titleCasePipe.transform(s.path);
				// If route is financial health indicator, change 'Health' to 'Financial health' in breadcrumbs (per spec)
				if (titleText === 'Health') {
					titleText = 'Financial Health'
				}
				// If the url array segment matches the mcag or gov type code on the activate route snapshot, replace segment with gov or gov type name
				const mcagOrGovTypeCode = routeSnapshot?.params['mcag'] || routeSnapshot?.params['govTypeCode'];
				if (titleText === mcagOrGovTypeCode && govNameOrGovType) {
					titleText = govNameOrGovType;
				}
				// Create new crumb and add to the list
				breadcrumbs.push(new Breadcrumb(titleText, '/' + route));
			}
		});

		// Handle comparison page case (multiple mcags), only keep 'Explore' and 'Individual Governments' crumbs
		if (routeSnapshot?.data['context'] instanceof GovernmentComparisonContext) {
			breadcrumbs = breadcrumbs.filter(crumb => crumb.label === 'Explore' || crumb.label === 'Individual Governments');
		}

		return breadcrumbs;
	}

	// Builds a route link with url segments
	routeLink(urlSegments: UrlSegment[]) {
		const tree = new UrlSegmentGroup(urlSegments, {});
		return tree.toString();
	}
}
